import { Campaign } from "@/types/campaign";
import { defineStore } from "pinia";

export type PanelType = 'campaign-management' | 'edit-informations' | 'edit-weightings' | 'edit-card' | 'add-consultant' | 'create-campaign';

export const useCampaignSelectorStore = defineStore("campaign-selector", () => {

  const isSlidingPanelOpen = ref(false);
  const isSubPanelOpen = ref(false);
  const currentSlidingPanel: Ref<PanelType> = ref(null);
  const selectedCampaign: Ref<Campaign> = ref(null);

  function closePanel() {
  isSubPanelOpen.value = false;
  isSlidingPanelOpen.value = false;
  currentSlidingPanel.value = null;
  selectedCampaign.value = null;
}

function closeSubPanel() {
  isSubPanelOpen.value = false;
  isSlidingPanelOpen.value = false;

  setTimeout(() => {
    currentSlidingPanel.value = 'campaign-management';
    isSlidingPanelOpen.value = true;
  }, 300);
}

function openSubPanel(panel: PanelType) {
  isSlidingPanelOpen.value = false;

  setTimeout(() => {
    currentSlidingPanel.value = panel;
    isSubPanelOpen.value = true;
    isSlidingPanelOpen.value = true;
  }, 300);
}

function openCreateCampaignPanel() {
  isSlidingPanelOpen.value = false;
  setTimeout(() => {
    currentSlidingPanel.value = 'create-campaign';
    isSlidingPanelOpen.value = true;
  }, 300);
}


function openPanel(campaign: Campaign) {
  currentSlidingPanel.value = 'campaign-management';
  selectedCampaign.value = campaign;
  isSlidingPanelOpen.value = true;
}

  return {
    isSlidingPanelOpen,
    isSubPanelOpen,
    currentSlidingPanel,
    selectedCampaign,

    closePanel,
    closeSubPanel,
    openSubPanel,
    openPanel,
    openCreateCampaignPanel,
  }
});